const API_ROOT = 'https://app-node.enterprisetalk.com:3000';
// const API_ROOT = 'http://192.168.16.179:3000';
const webPath = 'https://enterprisetalk.com';
// const webPath = 'http://192.168.16.179:3000';
// const webPath = 'https://ondot-enterprisetalk.b-cdn.net'
const API_ROOTT = 'https://app-node-enterprisetalk.ondotmail.com:3037';

export {API_ROOTT, API_ROOT,webPath};
